import BaseAPIService from './BaseAPIService';
import gql from 'graphql-tag';

export default class ReferenceService extends BaseAPIService {
	constructor() {
		super();
	}

	getReference() {
		return new Promise((resolve, reject) => {
			const query = gql`
				query getReference {
					categories {
						id
						name
						title
						children {
							id
							name
							title
							children {
								id
								name
								title
							}
						}
					}
					travelerTypes {
						id
						name
						title
					}
					countries {
						id
						name
						title
					}
					industries {
						id
						title
					}
				}
			`;
			return this.query({
				query,
			})
				.then((result) => {
					resolve(result.data);
				})
				.catch(reject);
		});
	}

	getLocationsByParentId(parentId) {
		return new Promise((resolve, reject) => {
			const query = require('../graphql/queries/locations.gql');
			const variables = {
				parentId,
			};
			return this.query({
				query,
				variables,
			})
				.then((result) => {
					resolve(result.data.locations);
				})
				.catch(reject);
		});
	}
}
